import { render, staticRenderFns } from "./UserTeamAssignment.vue?vue&type=template&id=7fb2f11a&scoped=true&"
import script from "./UserTeamAssignment.vue?vue&type=script&lang=js&"
export * from "./UserTeamAssignment.vue?vue&type=script&lang=js&"
import style0 from "./UserTeamAssignment.vue?vue&type=style&index=0&id=7fb2f11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb2f11a",
  null
  
)

export default component.exports